module.exports = __webpack_public_path__ + "img/2.b5edeb50.svg";